import React, { useCallback } from 'react';
import { useRouter } from 'next/router';

import SearchIcon from '../../Icons/Search';

import colors from '../../../utils/colorConstants';
import fastpanel from '../../../utils/fastpanel';

import useFirstInput from '../../../hooks/useFirstInput';
import ConstructorAutocompleteInput from '@/components/ConstructorAutocompleteInput';

const DesktopSearchInputSearchBC = () => {
  const router = useRouter();
  const { query } = router;
  const { q = '' } = query;

  const { inputValue, onInputChange } = useFirstInput(q);

  const seachSubmit = useCallback(
    (event: any) => {
      event.preventDefault();

      const query = event.target?.[0]?.value || '';

      fastpanel({
        name: 'pbr_search_requested',
        data: {
          entry_point: 'all',
          searched_for: query,
        },
      });

      const href = query ? `/search?q=${query}` : `/cards`;
      router.push(href);
    },
    [router]
  );

  return (
    <form
      action="/search"
      className="max-w-[42rem] w-full mx-auto"
      data-cnstrc-autosuggest
      method="get"
      onSubmit={seachSubmit}
    >
      <div className="relative flex items-center">
        <ConstructorAutocompleteInput
          autoCapitalize="none"
          className="paragraph-small bg-gallery text-lapel placeholder-charcoal py-0 h-10 pl-10 pr-6 rounded-full border-alto lg:pr-10 lg:pl-5"
          data-cnstrc-search-input
          name="q"
          onChange={onInputChange}
          placeholder="Search by design, theme, or category"
          type="text"
          value={inputValue}
        />
        <button
          aria-hidden="true"
          className="absolute w-6 h-6 left-0 mr-4 items-center lg:left-auto lg:right-0 lg:mr-4"
          data-cnstrc-search-submit-btn
          type="submit"
        >
          <SearchIcon fill={colors.charcoal} height="1.5rem" width="1.5rem" />
        </button>
      </div>
    </form>
  );
};

export default React.memo(DesktopSearchInputSearchBC);
